import React from 'react'
import Header from '../components/Header'
import Training from '../components/Traning'
import { Helmet } from 'react-helmet'

export default function Traning_website() {
  return (
    <div>
                    <Helmet>
        <title>Features | Andromeda</title>
        <meta name="description" content="Get in touch with us through our contact page." />
        <meta name="keywords" content="contact, support, help, andromeda sim" />
      </Helmet>
      <div className=''><Header/></div>
        <Training/>
    </div>
  )
}
